import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e312cba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "crypto-price-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('crypto-price'))
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.pair.currency_type_from === 'fiat')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass([
            _ctx.b('icon'),
            'fi',
            `fi-${_ctx.pair.country_from.toLowerCase()}`,
            'flag flag-from',
          ])
            }, null, 2))
          : (_ctx.currencyMap[_ctx.pair.currency_id_from])
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: _normalizeClass(["flag flag-from", _ctx.b('icon', { crypto: true })]),
                src: 
            require(`@/assets/images/crypto/${_ctx.currencyMap[
              _ctx.pair.currency_id_from
            ].toLowerCase()}.svg`)
          ,
                alt: ""
              }, null, 10, _hoisted_2))
            : _createCommentVNode("", true),
        (_ctx.pair.currency_type_to === 'fiat')
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass([
            _ctx.b('icon'),
            'fi',
            `fi-${_ctx.pair.country_to.toLowerCase()}`,
            'flag flag-to',
          ])
            }, null, 2))
          : (_ctx.currencyMap[_ctx.pair.currency_id_to])
            ? (_openBlock(), _createElementBlock("img", {
                key: 3,
                class: _normalizeClass(["flag flag-to", _ctx.b('icon', { crypto: true })]),
                src: 
            require(`@/assets/images/crypto/${_ctx.currencyMap[
              _ctx.pair.currency_id_to
            ].toLowerCase()}.svg`)
          ,
                alt: ""
              }, null, 10, _hoisted_3))
            : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('info'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('header'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('pair'))
        }, _toDisplayString(_ctx.displayedPair), 3)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('rates'))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('rate'))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('label'))
          }, _toDisplayString(_ctx.$t("Покупка")), 3),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('value'))
          }, _toDisplayString(_ctx.formattedBuyRate), 3)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.b('rate'))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('label'))
          }, _toDisplayString(_ctx.$t("Продажа")), 3),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.b('value'))
          }, _toDisplayString(_ctx.formattedSellRate), 3)
        ], 2)
      ], 2)
    ], 2)
  ], 2))
}